<template>
    <div class="checkout-goods">
        <div class="checkout-goods__item">
            <div>
                <img :src="result.picture.src"
                     :alt="result.picture.alt"
                >
            </div>
            <div class="checkout-goods__description">
                <a :href="result.detailPage" class="def-title-6">{{ result.name }}</a>
                <span v-for="prop in result.displayProperties" class="checkout-goods__size">{{ prop.name }}: {{ prop.value }}</span>
                <div class="prosentText" v-if="result.price.printDiscount">{{result.price.printDiscountPercent}}</div>
            </div>
            <div class="checkout-goods__price-wrapper">
                <div class="checkout-goods__price" v-if="result.price">
                    <p class="def-price">{{ result.price.quantity }} шт</p>
                    <p v-if="result.price.price < result.price.priceOld" class="def-price-old">{{ result.price.printPriceOld }}</p>
                    <p class="def-price">{{ result.price.printPrice }}</p>
                </div>
                <div v-if="result.price.printDiscount">
                    <p class="def-free">{{ result.price.printDiscount }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'checkout-goods',
        props: {
            result: {
                type: Object,
                default: () => {
                    return {
                        name: 'Name product',
                        price: {
                            printPrice: '100 grn',
                            printPriceOld: '150 grn',
                        },
                        picture: {
                            src: '/local/templates/love-you/images/front-end/checkout-item.png',
                            alt: 'Element',
                        },
                        displayProperties: [
                            {
                                name: 'testProp',
                                value: 'value of prop',
                            }
                        ]
                    }
                }
            }
        },
    }
</script>

<style lang="scss">
    .prosentText {
        width: 100%;
        color: #D80D44;
        font-weight: 500;
    }
    .checkout-goods{
        margin: 16px 0;
        &__item{
            display: grid;
            grid-template-columns: 64px 1fr auto;
            grid-column-gap: 8px;
            margin-bottom: 4px;
            @include point-md{
                grid-template-columns: 80px 1fr auto;
                grid-column-gap: 16px;
            }
            @include point-lg{
                grid-column-gap: 24px;
            }
        }
        &__price-wrapper{
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 8px 8px 8px 0;
            text-align: end;
            @include point-md{
                padding: 16px 16px 16px 0;
            }
            @include point-lg{
                padding: 24px 24px 24px 0;
            }
        }
        &__price{
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            margin-bottom: 4px;
            @include point-md{
                flex-direction: row;
            }
            @include point-lg{
                flex-direction: column;
            }
        }
        &__description{
            padding: 8px 0;
            @include point-lg{
                padding: 16px 0;
            }
            @include point-lg{
                padding: 24px 0;
            }
        }
        &__size{
            display: block;
            font-size: rem(14);
            line-height: 100%;
            color: #757575;
        }
        img{
            display: block;
            max-width: 100%;
        }
        .def-title-6{
            font-size: rem(14);
            margin-bottom: 4px;
            @include point-md{
                font-size: rem(16);
            }
            @include point-lg{
                font-size: rem(14);
            }
        }
        .def-price-old{
            margin-right: 5px;
        }
        .def-price-old, .def-price{
            font-size: rem(12);
            @include point-md{
                font-size: rem(14);
            }
            @include point-lg{
                font-size: rem(12);
            }
        }
        .def-free{
            font-size: rem(12);
        }
    }
</style>